export class DailyReports {
  constructor(
    public user: BaseUser,
    public totalVideos: number,
    public totalPhotos: number,
    public totalAudios: number,
    public totalDocuments: number,
    public totalOthers: number,
    public createdOn: Date
  ) {}
}

export class DailyReportsResponse {
  constructor(
    public User: BaseUserResponse,
    public TotalVideos: number,
    public TotalPhotos: number,
    public TotalAudios: number,
    public TotalDocuments: number,
    public TotalOthers: number,
    public CreatedOn: Date
  ) {}
}

export class SummaryReports {
  constructor(
    public user: BaseUser,
    public totalVideos: number,
    public totalPhotos: number,
    public totalAudios: number,
    public totalDocuments: number,
    public totalOthers: number
  ) {}
}

export class SummaryReportsResponse {
  constructor(
    public User: BaseUserResponse,
    public TotalVideos: number,
    public TotalPhotos: number,
    public TotalAudios: number,
    public TotalDocuments: number,
    public TotalOthers: number
  ) {}
}

export class BaseUserResponse {
  constructor(public FirstName: string, public LastName: string, public EmployeeID: string, public UID: string, public PictureFullPath: string) {}
}

export class BaseUser {
  constructor(public firstName: string, public lastName: string, public employeeId: string, public uid: string, public pictureFullPath: string) {}
}
